import React, { Component } from 'react';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import { Redirect } from 'react-router-dom';
import selectors from '../selectors';
import Loading from './Loading';

class RootView extends Component {
    static mapState = (state) =>
        mapSelectors(state, {
            isLoggedIn: selectors.login.getIsLoggedIn,
            wantLogin: selectors.login.getWantLogin,
        });

    render() {
        if (this.props.wantLogin) {
            return <Redirect to="/login" />;
        }
        if (!this.props.isLoggedIn) {
            return <Loading />;
        }
        return <Redirect to="/order" />;
    }
}

export default attach(RootView);



// WEBPACK FOOTER //
// ./app/views/Root.jsx